import PropTypes from 'prop-types';
import React from 'react';
import ContestStore from 'contest/stores/contest-store';
import { connectToStores } from 'fluxible-addons-react';

/**
 * For conditionally displaying a component based on the current stage of a contest
 * e.g. let MyComponentOnlyInOpenStage = contestStageSelector(['open'], MyComponent);
 */
export default function contestStageSelector(validStages = [], Component) {
    const ToggleComponent = ({ enabled, children }) => {
        return enabled ? <Component>{children}</Component> : children;
    };

    ToggleComponent.propTypes = {
        enabled: PropTypes.bool.isRequired,
        children: PropTypes.node,
    };

    return connectToStores(ToggleComponent, [ContestStore], (context) => {
        const contestStage = context.getStore(ContestStore).getStage();
        const contestLockState = context.getStore(ContestStore).getLockState();
        return {
            enabled: contestLockState === 'unlocked' && validStages.includes(contestStage),
        };
    });
}



// WEBPACK FOOTER //
// ./src/web/js/contest/components/onboarding-prompts/contestStageSelector.js